/*global angular,env */
'use strict';

angular.module('MrDWebApp').controller('AuthCtrl', function ($scope, $cookies, $stateParams, storage, $http, $window, $state, $previousState, loginFactory, $rootScope, $location, sendbird) {

  var _auth = this;


  // @todo Remove this...

  $previousState.memo('caller');

  _auth.sharehost = ''; //'http://localhost:8080'; //https://seo-www.qa.mrd.com //http://localhost:8080


  var queryParams = $location.search();
  _auth.shareAuth = queryParams && queryParams.share === 'true';
  _auth.shareAuthWith = document.referrer;

  $http.get('/api/seohost').then(function(res){
    if (res.data && (res.data.length || res.data.length===0 || !res.data.success)) { //string or array or unsuccessful
      console.log('Unexpected response form /seohost');
      return;
    }
    _auth.sharehost = res.data.data;
    _auth.shareAuthWith = _auth.sharehost; //OVERRIDE REFERRER

    if ($scope._rc.access && $scope._rc.access.auth && ~$scope._rc.access.auth.indexOf('Basic')) {
      //console.log('User auth ready to be sent.');
      $scope._rc.shareSession($scope._rc.access.auth.split(' ')[1], _auth.sharehost)
      .then(function() {
        //$window.location = _auth.sharehost;
        if ($state.current.name !== 'reset' && $state.current.name !== 'forgot') {
          $window.location = '/';
        }
      });
    }
  }).catch(function(){
    console.log('Error response form /seohost');
  });
  
  // console.log('$rootScope.postLoginState', $rootScope.postLoginState);
  // console.log('Prev (Nav) State:', $previousState.get('caller').state);

  // // The app.js router 'detector' has already stored the state, but if it hasn't
  if($previousState.get('caller').state !== null){
    $previousState.memo('caller'); // Always Memo the Caller
  }
  if($previousState.get('caller').state && $previousState.get('caller').state.name  !== 'checkout'){
    //console.log('caller - not checkout - save..');
    $previousState.memo('caller');
  }

  _auth.passwordIssue = '';
  _auth.passwordConfirmIssue = '';
  _auth.passwordMatch = function() {
    //console.log('passwords', _auth.new_password, _auth.new_password_confirmed);
    if (_auth.new_password && _auth.new_password.length > 6) {
      _auth.passwordIssue = '';
    } else {
      _auth.passwordIssue = 'Password needs to be 7 characters or more.';
    }
    if (_auth.new_password_confirmed && _auth.new_password_confirmed === _auth.new_password) {
      _auth.passwordConfirmIssue = '';
    } else {
      _auth.passwordConfirmIssue = 'Confirmed password needs to match the password.';
    }
    //_auth.failed_message = _auth.passwordIssue || _auth.passwordConfirmIssue || '';
  };

  // Save 'other' previous state entries...
  if($previousState.get('caller').state !== null){
    if($previousState.get('caller').state.name !== 'login' && $previousState.get('caller').state.name !== 'register') {
      $previousState.memo('original');
      $scope._rc.variables.originalState = $previousState.get('original');
    }
  }

  $scope._rc.bodyClass = 'html-auth';

  _auth.cellmatch_input = '';
  _auth.isWorking = false;
  _auth.failed_message = '';
  _auth.success = false;
  _auth.form = {
    profile : {}
  };

  if(($state.current.name === 'forgot' || $state.current.name === 'login') && $rootScope.email_partial !== ''){
    _auth.email = $rootScope.email_partial;
  }
  
  _auth.chatSignup = function(){
    if (sendbird.isSignedUp()) return Promise.resolve();
    return sendbird.signup($scope._rc.access.user.id.toString(), $scope._rc.access.user.profile.first_name)
    .catch(function(er){
      
      // SENTRY
      try {
        var msg = 'Driver Chat sign up: '+ (er.message || er);
        console.warn(msg);
        window.Raven.captureMessage(msg, {level:'warning'});
      } catch (error) {
        console.warn('Could not report error.', error);
      }
    });
  };

  _auth.loginLink = function(){
    if(env.name === 'PP'){
      return 'https://dw96f.app.goo.gl/mvEP'; // PP
    }
    if(env.name === 'PROD'){
      return 'https://sk6a2.app.goo.gl/eJbW'; // Live
    }
    if(env.name === 'QA'){
      return 'https://mrdeliveryqa.page.link/gCjL'; //QA
    }
    return '/login'; // dev
  };


  _auth.login = function () {

    _auth.isWorking = true;
    _auth.failed_message = '';

    //console.log(_auth.email, _auth.password);
    var auth_hash = btoa(_auth.email + ':' + _auth.password);
    var basic_auth_encoded = 'Basic ' + auth_hash;

    loginFactory.login(basic_auth_encoded, function (response) {

      _auth.isWorking = false;
      $rootScope.email_partial = '';
      //console.log(response)
      // @todo Serious Cleanup Needed
      if (response.id) {
        $scope._rc.access.loggedin = true;
        $scope._rc.access.auth = basic_auth_encoded;
        $scope._rc.access.user.id = response.id;
        $scope._rc.access.user.name = response.name;
        $scope._rc.access.user.profile = response.profile;
        if(response.saved_addresses){
          $scope._rc.access.user.saved_addresses = response.saved_addresses;
        }
        storage.set('mrd-web-access', $scope._rc.access);
        $http.defaults.headers.common.Authorization = $scope._rc.access.auth;
        // $http.defaults.headers.common['x-user-id'] = response.id;

        window.Raven.setUserContext({
          id: response.id,
          email: response.profile.email
        });

        /* Analytics */ $scope._rc.trackLoginSuccess();
        /* Firebase Push */ 
        /* $rootScope.firebasePushInit(response.id) */
        $scope._rc.shareSession(auth_hash, _auth.sharehost)
        .then(function() {
          return _auth.chatSignup();
        })
        .then(function() {
          if (_auth.shareAuth) $window.location = _auth.sharehost;
          else if ($rootScope.postLoginState) {
            var targetState = $rootScope.postLoginState;
            $rootScope.postLoginState = null;
            $state.go(targetState);
          } else if(typeof $scope._rc.variables.originalState !== 'undefined' && $previousState.get('caller').state !== $scope._rc.variables.originalState.state) {
            $previousState.go('original'); // Most likely take you back to CART page...
          } else {
            if ($previousState.get('caller').state === null ||
              $previousState.get('caller').state.name === 'reset' ||
              $previousState.get('caller').state.name === 'login' ||
              $previousState.get('caller').state.name === 'register' ||
              $previousState.get('caller').state.name === 'forgot') {
              if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');// Go Home
            } else {
              $previousState.go('caller'); // Go back to where you were.
            }
          }
        });

      }
      else if(response.data && response.data.error){
        /* Analytics */ $scope._rc.trackLoginFailure(response);
        if (response.data.error.http_response_code === 404) {
          _auth.failed_message = response.data.error.friendly_message;
        } else {
          _auth.failed_message = '('+response.data.error.http_response_code+') '+response.data.error.friendly_message;
        }

      } else {
        //console.log('else');
          /* Analytics */ $scope._rc.trackLoginFailure();
         _auth.failed_message = 'An error occurred. Please check your connection.';
      }


    }, function (response) {

      /* Analytics */ $scope._rc.trackLoginFailure(response);

      _auth.isWorking = false;
      _auth.failed_message = 'An error occurred. Please check your connection.';
      //console.log('fail?');

      if(response.data.error && response.data.error.friendly_message) {
        _auth.failed_message = response.data.error.friendly_message;
      }
    });

  };

  _auth.labelText = function(formObject,reqText,validText){

    if(formObject.$error && !formObject.$valid && formObject.$viewValue){
      if(formObject.$error.minlength){
        return 'Not Long Enough';
      }
      if(formObject.$error.email){
        return 'Invalid Email';
      }
      return reqText;
    }
    else if(formObject.$valid || !formObject.$viewValue){
      return validText;
    }
  };
  /* @todo Rework / remove */
  _auth.labelTextCellMatch = function(formObject,reqText,validText,invalidText){

    if(!formObject.cellmatch.$valid){
      return reqText;
    } else if(formObject.cellmatch.$valid && formObject.phone_1.$viewValue !== formObject.cellmatch.$viewValue){
      return invalidText;
    } else {
      return validText;
    }
  };

  _auth.register = function () {

    _auth.isWorking = true;
    _auth.failed_message = '';

    _auth.form.user_source = {
      'application': 'CUSTOMER_APP',
      'client_id': 'WEB_APP',
      'client_version': $rootScope.application_version,
      'platform_version': navigator.userAgent
    };



    loginFactory.register(_auth.form, function (response) {
      _auth.isWorking = false;

      //console.log(_auth.email, _auth.password);
      var auth_hash = btoa(_auth.form.name + ':' + _auth.form.password);
      var basic_auth_encoded = 'Basic ' + auth_hash;

      if (response.id) {
        $scope._rc.access.loggedin = true;
        $scope._rc.access.auth = basic_auth_encoded;
        $scope._rc.access.user.id = response.id;
        $scope._rc.access.user.name = response.name;
        $scope._rc.access.user.profile = response.profile;

        storage.set('mrd-web-access', $scope._rc.access);
        $http.defaults.headers.common.Authorization = $scope._rc.access.auth;
        // $http.defaults.headers.common['x-user-id'] = response.id;

        window.Raven.setUserContext({
          id: response.id,
          email: response.profile.email
        });

        /* Analytics */ $scope._rc.trackRegisterSuccess();
        $window._adjustEvent('xosaux'); //registration_completed

        $scope._rc.shareSession(auth_hash, _auth.sharehost)
        .then(function() {
          return _auth.chatSignup();
        })
        .then(function() {
          if (_auth.shareAuth) $window.location = _auth.sharehost;
          else if(typeof $scope._rc.variables.originalState !== 'undefined' && $previousState.get('caller').state !== $scope._rc.variables.originalState.state) {
            /* Bit Messy... but should take you to cart once registering */
            $previousState.go('original'); // Most likely take you back to CART page...
          } else {
            if ($previousState.get('caller').state === null ||
              $previousState.get('caller').state.name === 'login') {
              if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');// Go Home
            } else {
              // After successful registration but was previously on Login... go to original caller..
              $previousState.go('caller'); // Go back to where you were.
            }
          }
        });

      }

    }, function (response) {

      /* Analytics */ $scope._rc.trackRegisterFailure();

      _auth.isWorking = false;
      if(response.data.error) {
        _auth.failed_message = response.data.error.friendly_message;
      } else {
        _auth.failed_message = 'Something went wrong';
      }
    });
  };

  _auth.forgot = function () {

    _auth.isWorking = true;
    _auth.failed_message = '';

    loginFactory.forgot(_auth.email, function (response) {
      _auth.isWorking = false;
      _auth.success = true;
      _auth.success_message = response.friendly_message;


    }, function (response) {
      _auth.isWorking = false;
      if(response.data.error) {
        _auth.failed_message = response.friendly_message;
      } else {
        _auth.failed_message = 'Something went wrong';
      }
    });
  };

  if ($state.current.name === 'reset') {
    _auth.invalidPasswordResetToken = !$stateParams.token || !$stateParams.token.length;

    if (_auth.invalidPasswordResetToken) {
      _auth.failed_message = 'Your reset password link contains no token. Please use the complete URL from your email.';
    }
  }

  _auth.reset = function () {

    _auth.isWorking = true;
    _auth.failed_message = '';

    loginFactory.reset(_auth.new_password, _auth.new_password_confirmed, $stateParams.token, function (response) {
      _auth.isWorking = false;

      if(response.data && response.data.error) {
        _auth.failed_message = response.data.error.friendly_message;
        return;
      }

      _auth.success = true;
      _auth.success_message = response.friendly_message;

      // LOGOUT
      $scope._rc.remChatToken()
      .then(function(){
        return $scope._rc.unregPushToken();
      })
      .then(function(){
        $scope._rc.reset();
        if (window.env.domainSplit) {
          window.clearAuthOnSEOHost();
        }
      });

    }, function (response) {
      _auth.isWorking = false;
      if(response.data && response.data.error) {
        _auth.failed_message = response.data.error.friendly_message;
      } else {
        _auth.failed_message = 'Your password could not be reset. Please check your internet connection.';
      }

      $rootScope.$broadcast('global_message:show',{
        'name': 'login_issue',
        'for_state': 'reset',
        'title': 'Password could not be reset',
        'error' : {
          'friendly_message': _auth.failed_message
        },
        'confirm' : false,
        'deny' : false,
        customActions: [
          {label: 'Request a new reset link', style:'primary', action: function(){
            $state.go('forgot');
          }},
          {label: 'Return home', style:'secondary', action: function(){
            $window.location = _auth.sharehost+'/';
          }},
          {label: 'Contact Support', style:'secondary', action: function(){
            $window.location = _auth.sharehost+'/contact';
          }}
        ]
      });
    });
  };

  _auth.softStoreEmail = function(){
    $rootScope.email_partial = _auth.email;
  };


});
